import { UserEditPage } from '@components'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/companies_/$companyId_/user_/$userId_/edit/')({
  component: UserEditPage,
})
